import { Suspense } from 'react';
import { Await, useLoaderData } from 'react-router-dom';
import PaginatedCards from '../../components/paginatedCards/PaginatedCards';
import Loader from '../../components/loader/Loader';
import BannerOne from '../../components/ads/300x250';
import BannerThree from '../../components/ads/300x250three';
import './favoritePage.scss';

function FavoritePage() {
  const data = useLoaderData();

  return (
    <div className="favoritePage">
      <div className="listContainer">
        <div className="wrapper">
          <Suspense fallback={<Loader />}>
            <Await
              resolve={data.postResponse}
              errorElement={<p>Error loading saved ads</p>}
            >
              {(postResponse) => {
                const posts = postResponse?.data?.savedPosts ?? [];
                return posts.length > 0 ? (
                  <PaginatedCards posts={posts} saved />
                ) : (
                  <p>No saved ads</p>
                );
              }}
            </Await>
          </Suspense>
        </div>
      </div>

      <div className="adsContainer">
        <BannerOne />
        <BannerThree />
      </div>
    </div>
  );
}

export default FavoritePage;
